import { ReportComponentActionIntent, ReportComponentExportType } from '@core/reports-types';

export const EXPORT_INTENT_TO_TYPE: Partial<
  Record<ReportComponentActionIntent, ReportComponentExportType>
> = {
  [ReportComponentActionIntent.ExportPng]: ReportComponentExportType.IMG,
  [ReportComponentActionIntent.ExportCsv]: ReportComponentExportType.CSV,
  [ReportComponentActionIntent.ExportXlsx]: ReportComponentExportType.XLSX,
  [ReportComponentActionIntent.ExportPdf]: ReportComponentExportType.PDF,
};
